import { render } from "./ReminderEmails.vue?vue&type=template&id=2cf01a6f"
import script from "./ReminderEmails.vue?vue&type=script&lang=js"
export * from "./ReminderEmails.vue?vue&type=script&lang=js"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__